import { createAuth0 } from '@auth0/auth0-vue';
import type { Auth0VueClient } from '@auth0/auth0-vue';

declare module '#app' {
  interface NuxtApp {
    $auth0: Auth0VueClient;
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  // Skip initialization during SSR
  if (config.app.ssr) {
    return {
      provide: {
        auth0: {},
      },
    };
  }

  const auth0 = createAuth0({
    domain: config.public.auth0.domain,
    clientId: config.public.auth0.clientId,
    authorizationParams: {
      redirect_uri: window.location.origin + '/callback',
      audience: config.public.auth0.audience,
      scope: 'openid profile email read:permissions',
    },
    cacheLocation: 'localstorage',
  });

  nuxtApp.vueApp.use(auth0);

  return {
    provide: {
      auth0,
    },
  };
});
